var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 39.375C31.8198 39.375 39.375 31.8198 39.375 22.5C39.375 13.1802 31.8198 5.625 22.5 5.625C13.1802 5.625 5.625 13.1802 5.625 22.5C5.625 31.8198 13.1802 39.375 22.5 39.375Z",
    fill: "#ED1C00",
    stroke: "#ED1C00",
    strokeWidth: 1.125
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5307 30.5928C17.3009 29.8227 18.213 29.2091 19.2166 28.7857C20.2564 28.3495 21.3726 28.1248 22.5002 28.1248C23.6278 28.1248 24.744 28.3495 25.7838 28.7857C26.7873 29.2091 27.6994 29.8227 28.4697 30.5928",
    stroke: "#FBFBFB",
    strokeWidth: 2.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 16.875H25.3125",
    stroke: "#FBFBFB",
    strokeWidth: 2.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 16.875H16.875",
    stroke: "#FBFBFB",
    strokeWidth: 2.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.58418872643376a7f98df5b853e9d6e6.svg";
export { ForwardRef as ReactComponent };